<template>
    <div class="service-modal show">
        <div class="modal-mbway-container">
            <div class="modal-mbway">
                <div class="row">

                    <h3 class="text-orange text-center my-3">Pagamento por cartão de crédito</h3>
                    <p class="sub-title">Por favor, preenche os dados para completar a tua encomenda</p>

                    <div class="mbway-content">
                        <form :action="actionUrl" class="paymentWidgets" data-brands="VISA MASTER AMEX"></form>
                    </div>

                    <div class="col-md-12 text-center">
                        <button class="btn-text-only" @click="cancel">
                            Cancelar pagamento
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
    props: {
        actionUrl: {
            required: true
        }
    },
    data() {
        return {
        }
    },
    created() {
        document.querySelector('html').classList.add('no-scroll');
        document.querySelector('body').classList.add('no-scroll');
    },
    methods: {
        cancel() {
            this.$emit('close');
            document.querySelector('html').classList.remove('no-scroll');
            document.querySelector('body').classList.remove('no-scroll');
        }
    }
}

</script>

<style>

</style>
